import { render } from "./ScoreSaveErrorHandler.vue?vue&type=template&id=63584edf&ts=true"
import script from "./ScoreSaveErrorHandler.vue?vue&type=script&lang=ts"
export * from "./ScoreSaveErrorHandler.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__